import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { ArrowLeft, Quote, Heart, Coffee } from 'lucide-react';
export function Thoughts() {
  return <div className="bg-zen-bg min-h-screen text-zen-text" data-id="element-189">
      <Navbar data-id="element-190" />
      <main className="pt-32 pb-20 px-6" data-id="element-191">
        <div className="max-w-4xl mx-auto" data-id="element-192">
          <a href="/" className="inline-flex items-center gap-2 text-zen-text/60 hover:text-zen-accent mb-8 transition-colors" data-id="element-193">
            <ArrowLeft className="w-4 h-4" data-id="element-194" /> Back to Home
          </a>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-6xl font-moon-dance mb-6" data-id="element-195">
            Thoughts & Musings
          </motion.h1>

          <p className="text-xl text-zen-text/70 mb-16 leading-relaxed max-w-2xl" data-id="element-196">
            A collection of reflections on life, technology, and the quiet
            moments in between.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-197">
            {[{
            title: 'The Art of Debugging Life',
            date: 'March 15, 2024',
            icon: Coffee,
            content: "Just as we trace back errors in code, sometimes we need to trace back our emotions to find the root cause. It's not about fixing everything instantly, but understanding the flow."
          }, {
            title: 'Silence is a Feature',
            date: 'February 28, 2024',
            icon: Quote,
            content: "In a world of constant notifications, silence isn't a bug—it's a premium feature. Learning to sit with my own thoughts has been the most challenging upgrade."
          }, {
            title: 'Kindness as an API',
            date: 'January 10, 2024',
            icon: Heart,
            content: 'If we treated our interactions like API calls, would we return 200 OK or 400 Bad Request? Kindness is the most reliable protocol for human connection.'
          }].map((thought, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="bg-white p-8 rounded-3xl shadow-sm border border-zen-text/5 hover:shadow-md transition-shadow" data-id="element-198">
                <div className="flex items-center justify-between mb-6" data-id="element-199">
                  <div className="p-3 bg-amber-50 rounded-full text-amber-600" data-id="element-200">
                    <thought.icon className="w-5 h-5" data-id="element-201" />
                  </div>
                  <span className="text-sm text-zen-text/40 font-medium" data-id="element-202">
                    {thought.date}
                  </span>
                </div>

                <h3 className="text-2xl font-serif font-bold text-zen-text mb-4" data-id="element-203">
                  {thought.title}
                </h3>
                <p className="text-zen-text/70 leading-relaxed" data-id="element-204">
                  {thought.content}
                </p>
                <button className="mt-6 text-zen-accent font-medium hover:underline" data-id="element-205">
                  Read more
                </button>
              </motion.div>)}
          </div>
        </div>
      </main>
      <Footer data-id="element-206" />
    </div>;
}